import { render, staticRenderFns } from "./ForbiddenKeywordsHead.vue?vue&type=template&id=76b5ceb5&scoped=true"
import script from "./ForbiddenKeywordsHead.vue?vue&type=script&lang=js"
export * from "./ForbiddenKeywordsHead.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenKeywordsHead.vue?vue&type=style&index=0&id=76b5ceb5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b5ceb5",
  null
  
)

export default component.exports